import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../AppContext';

interface HeaderProps {
  showConnectAccounts?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showConnectAccounts = false }) => {
  const navigate = useNavigate();
  const { userProfile, signOut } = useApp();

  const handleHomeClick = () => {
    // Always go to overview when clicking logo
    navigate('/mmt/overview');
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <header className="w-full bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo / Home Button */}
        <button
          onClick={handleHomeClick}
          className="text-2xl font-bold text-primary hover:text-primary/80 transition-colors"
        >
          Money Mindset Tool
        </button>

        {/* Navigation */}
        <div className="flex items-center gap-6">
          {/* Main navigation links */}
          {userProfile && (
            <>
              <button
                onClick={() => navigate('/mmt/overview')}
                className="text-gray-700 font-semibold hover:text-primary transition-colors"
              >
                Overview
              </button>
              <button
                onClick={() => navigate('/mmt/dashboard')}
                className="text-gray-700 font-semibold hover:text-primary transition-colors"
              >
                Dashboard
              </button>
              <button
                onClick={() => navigate('/mmt/landing')}
                className="text-gray-700 font-semibold hover:text-primary transition-colors"
              >
                Connect Accounts
              </button>
            </>
          )}

          {/* Profile button with dropdown */}
          {userProfile && (
            <div className="relative group">
              <button className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full hover:bg-gray-200 transition-all">
                <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-semibold">
                  {userProfile.firstName?.[0] || userProfile.email?.[0] || 'U'}{userProfile.lastName?.[0] || ''}
                </div>
                <span className="font-semibold text-gray-700">
                  {userProfile.firstName || userProfile.email?.split('@')[0] || 'User'}
                </span>
              </button>

              {/* Dropdown */}
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                <button
                  onClick={() => navigate('/mmt/profile')}
                  className="w-full text-left px-4 py-3 hover:bg-gray-100 font-semibold text-gray-700"
                >
                  Profile
                </button>
                <button
                  onClick={() => navigate('/')}
                  className="w-full text-left px-4 py-3 hover:bg-gray-100 font-semibold text-gray-700"
                >
                  Back to Tools
                </button>
                <button
                  onClick={handleSignOut}
                  className="w-full text-left px-4 py-3 hover:bg-gray-100 rounded-b-lg font-semibold text-red-600"
                >
                  Sign Out
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
